/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
  return {
    mode: theme?.customization?.navType,
    common: {
      black: theme.colors?.darkPaper
    },
    primary: {
      light: theme.colors?.primaryLight,
      main: theme.palette?.primary.main,
      dark: theme.colors?.primaryDark,
      200: theme.colors?.primary200,
      800: theme.colors?.primary800
    },
    secondary: {
      light: theme.colors?.secondaryLight,
      main: theme.colors?.secondaryMain,
      dark: theme.colors?.secondaryDark,
      200: theme.colors?.secondary200,
      800: theme.colors?.secondary800
    },
    error: {
      light: theme.colors?.errorLight,
      // Retuned for a dark ground: #f44336 sits at 3.9:1 on the panel surface, under the
      // 4.5:1 floor for the error text it has to carry.
      main: theme.colors?.stateError,
      dark: theme.colors?.errorDark
    },
    orange: {
      light: theme.colors?.orangeLight,
      main: theme.colors?.orangeMain,
      dark: theme.colors?.orangeDark
    },
    warning: {
      light: theme.colors?.warningLight,
      main: theme.colors?.stateWarning,
      dark: theme.colors?.warningDark
    },
    info: {
      light: theme.colors?.primary200,
      main: theme.colors?.stateInfo,
      dark: theme.colors?.primary800
    },
    success: {
      light: theme.colors?.successLight,
      200: theme.colors?.success200,
      // #00e676 is a neon green that pulls focus off the primary action wherever a
      // status pill appears. Same hue, tamed for a dark UI.
      main: theme.colors?.stateSuccess,
      dark: theme.colors?.successDark
    },
    grey: {
      50: theme.colors?.grey50,
      100: theme.colors?.grey100,
      500: theme.darkTextSecondary,
      600: theme.heading,
      700: theme.darkTextPrimary,
      900: theme.textDark
    },
    dark: {
      light: theme.colors?.darkTextPrimary,
      main: theme.colors?.darkLevel1,
      dark: theme.colors?.darkLevel2,
      800: theme.colors?.darkBackground,
      900: theme.colors?.darkPaper
    },
    text: {
      primary: theme.darkTextPrimary,
      secondary: theme.darkTextSecondary,
      disabled: theme.colors?.textDisabled,
      dark: theme.textDark,
      hint: theme.darkTextSecondary
    },
    divider: theme.divider,
    background: {
      paper: theme.paper,
      default: theme.backgroundDefault
    },
    // The surface ladder, exposed on the palette so components can say what they MEAN
    // (`surface.raised`) instead of pasting a hex that happens to look right. Anything
    // reaching for a literal dark value should reach for one of these six instead.
    surface: {
      canvas: theme.colors?.canvas,
      chrome: theme.colors?.chrome,
      main: theme.colors?.surface,
      raised: theme.colors?.raised,
      hover: theme.colors?.hover,
      inset: theme.colors?.inset
    },
    accent: {
      main: theme.colors?.secondaryMain,
      text: theme.colors?.accentText,
      soft: theme.colors?.accentSoft
    }
  };
}
